module.exports = __webpack_public_path__ + "static/media/evaluating.ac75aad8.gif";